import React, { Component } from 'react'
import { withRouter, Route, Switch } from 'react-router-dom'
import Home from './Home'
import Company from './Company'
import Professional from './Professional'
import ResetPassword from './ResetPassword'

const hideCookieConsentBanner = () => {
  ;[
    '#cc-main',
    '#cc--main',
    '.cc-window',
    '.cc-banner',
    '[id*="cookie-consent"]',
    '[class*="cookie-consent"]'
  ].forEach(selector => {
    document.querySelectorAll(selector).forEach(el => el.remove())
  })
  Array.from(document.body.children).forEach(el => {
    if (el.id === 'root') return
    if (el.textContent && el.textContent.indexOf('We use cookies') !== -1) {
      el.remove()
    }
  })
}

class Application extends Component {
  componentDidMount() {
    this.syncCookieBanner(this.props.location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location
    if (pathname !== prevProps.location.pathname) {
      this.syncCookieBanner(pathname)
    }
  }

  syncCookieBanner = pathname => {
    if (pathname !== '/' && pathname !== '') {
      hideCookieConsentBanner()
    }
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/company/:userId" component={Company} />
        <Route path="/professional/:userId" component={Professional} />
        <Route path="/:userId/verify/:token" component={Home} />
        <Route path="/:userId/resetPassword/:token" component={ResetPassword} />
      </Switch>
    )
  }
}

export default withRouter(Application)
